export const initCommunicationFilters = () => ({
    communicationDateFrom: null,
    communicationDateTo: null,
    accountType: null,
    subject: null,
    createdDateFrom: null,
    createdDateTo: null,
    accountName: null,
    modifiedDateFrom: null,
    modifiedDateTo: null,
    type: null,
    assignedToId: null,
    active: true,
})
